import { FundingDetailsActionDispatch, FundingDetailsReduxTypes } from "./types";

export const createFundingDetails = (payload: any): FundingDetailsActionDispatch => ({
    type: FundingDetailsReduxTypes.FUNDING_DETAILS_REPORT,
    payload: payload
})